export const GET_CONTACT_SAVED_SETS = 'GET_CONTACT_SAVED_SETS'
export const GET_SMART_SET = 'GET_SMART_SET'
export const GET_ALL_SMART_SETS = 'GET_ALL_SMART_SET'
export const GET_MY_SMART_SETS = 'GET_MY_SMART_SET'
export const SAVE_SMART_SET = 'SAVE_SMART_SET'
export const UPDATE_SMART_SET = 'UPDATE_SMART_SET'
export const DELETE_SMART_SET = 'DELETE_SMART_SET'
